import {
  createDefaultVendorOrderInformationData,
  IVendorOrderInformationData,
  IVendorOrderInformationRequest,
} from './IVendorOrderInformation';

export interface IVendorTaxCertificationInformationRequest
  extends Omit<IVendorOrderInformationRequest, 'titleSearchId'> {
  taxCertificationRequestId: string;
  eta?: string;
}

export interface IVendorTaxCertificationInformationData extends Omit<IVendorOrderInformationData, 'titleSearchId'> {
  taxCertificationRequestId: string;
  eta?: string;
}

export const createDefaultVendorTaxCertificationRequestsData = (): IVendorTaxCertificationInformationData => {
  const { titleSearchId, ...rest } = createDefaultVendorOrderInformationData();
  return {
    ...rest,
    taxCertificationRequestId: '',
  };
};

export const convertFromVendorTaxCertificationInformationRequestToVendorTaxCertificationInformationData = (
  data: IVendorTaxCertificationInformationRequest
): IVendorTaxCertificationInformationData => data;
